"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SendButton_1 = require("../buttons/SendButton");
const store_1 = require("../../../../store");
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const stripe_js_1 = require("@stripe/stripe-js");
const __1 = require("../../../..");
const utils_1 = require("../../../../services/utils");
const theme_1 = require("../../../../services/theme");
const PaymentInput = ({ options, onSubmit, stepIndex, buttonLabel }) => {
    var _a, _b, _c;
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    const { fontFamily, colors } = (0, theme_1.parseTheme)(chatbot);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const stripe = (0, react_stripe_js_1.useStripe)();
    const [isComplete, setIsComplete] = (0, react_1.useState)(false);
    const elements = (0, react_stripe_js_1.useElements)();
    // Handle real-time validation errors from the card Element.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (event) => {
        setIsComplete(event.complete);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        event.preventDefault();
        if (!stripe || !elements)
            throw new Error("stripe or elements not found.");
        setLoading(true);
        const card = elements.getElement(react_stripe_js_1.CardElement);
        if (!card)
            throw new Error("card not found");
        const { token } = yield stripe.createToken(card);
        if (!token)
            throw new Error("token not found");
        const amount = options.amount;
        try {
            yield pay({
                stripe,
                stepIndex,
                chatbot,
                paymentInfo: {
                    amount: amount * 100,
                    currency: options.currency,
                    token,
                },
                options,
            });
            onSubmit();
        }
        catch (err) {
            console.error(err);
            onSubmit((_d = err.toString()) !== null && _d !== void 0 ? _d : "server_error");
        }
    });
    return (react_1.default.createElement("div", { className: "flex flex-col w-full lg:w-5/6" },
        react_1.default.createElement("div", { className: "flex flex-1" },
            react_1.default.createElement("form", { className: "flex w-full p-2 rounded-lg typebot-input", onSubmit: handleSubmit },
                react_1.default.createElement("div", { className: "flex items-center w-full bg-transparent" },
                    react_1.default.createElement(react_stripe_js_1.CardElement, { id: "card-element", className: "flex-1", options: {
                            style: {
                                base: {
                                    fontFamily: `${fontFamily}, Inter, sans-serif`,
                                    fontSmoothing: "antialiased",
                                    fontSize: "16px",
                                    color: colors.inputColor
                                        ? colors.inputColor.textColor.value
                                        : "#303235",
                                    "::placeholder": {
                                        color: (_c = (_b = (_a = colors.inputColor) === null || _a === void 0 ? void 0 : _a.placeholder) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "#9095a0",
                                    },
                                },
                                invalid: {
                                    color: "#FF3131",
                                    iconColor: "#FF3131",
                                },
                            },
                        }, onChange: handleChange })),
                isComplete && react_1.default.createElement(SendButton_1.SendButton, { loading: loading, label: buttonLabel })))));
};
const PaymentInputElement = react_1.default.memo((props) => {
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    const [stripe] = (0, react_1.useState)((0, stripe_js_1.loadStripe)(props.options.publicKey));
    return (react_1.default.createElement(react_stripe_js_1.Elements, { stripe: stripe, options: { locale: chatbot.language } },
        react_1.default.createElement(PaymentInput, Object.assign({}, props))));
});
const pay = ({ stripe, paymentInfo, options, chatbot, stepIndex, }) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!stripe)
            return;
        const { pathname } = window.location;
        const paymentIntentBody = {
            amount: paymentInfo.amount,
            currency: paymentInfo.currency,
            chatbotId: "typebotId" in chatbot ? chatbot.typebotId : chatbot.id,
            stepIndex,
            preview: pathname.endsWith("preview-full-page") ||
                (pathname.includes("buildingChatbots") && pathname.endsWith("debug")),
        };
        if ((_a = options.billingDetails) === null || _a === void 0 ? void 0 : _a.email) {
            const email = (0, __1.parseVariables)(options.billingDetails.email, chatbot.variables);
            if (email !== "") {
                paymentIntentBody.email = email;
            }
        }
        const response = yield fetch(`${(0, utils_1.getCloudFunctionsOrigin)()}/createPaymentIntent`, {
            method: "POST",
            body: JSON.stringify(paymentIntentBody),
        }).catch((err) => {
            console.error("Error while calling `createPaymentIntent`", err);
            reject(err);
        });
        if (!response)
            return;
        const payment_method = parsePaymentMethod(paymentInfo, options, chatbot);
        const result = yield stripe.confirmCardPayment((yield response.json()).clientSecret, {
            payment_method,
        });
        if (result.error) {
            console.error("Error while calling `confirmCardPayment`", result.error.message);
            reject(result.error.code);
            return;
        }
        if (result.paymentIntent.status === "succeeded") {
            resolve();
        }
    }));
});
exports.default = PaymentInputElement;
const parsePaymentMethod = (paymentInfo, options, chatbot) => {
    const payment_method = {
        card: { token: paymentInfo.token.id },
    };
    if (options.billingDetails) {
        payment_method.billing_details = {};
        if (options.billingDetails.name) {
            const name = (0, __1.parseVariables)(options.billingDetails.name, chatbot.variables);
            if (name !== "") {
                payment_method.billing_details.name = name;
            }
        }
        if (options.billingDetails.email) {
            const email = (0, __1.parseVariables)(options.billingDetails.email, chatbot.variables);
            if (email !== "") {
                payment_method.billing_details.email = email;
            }
        }
        if (options.billingDetails.phone) {
            const phone = (0, __1.parseVariables)(options.billingDetails.phone, chatbot.variables);
            if (phone !== "") {
                payment_method.billing_details.phone = phone;
            }
        }
    }
    return payment_method;
};
//# sourceMappingURL=PaymentInput.js.map